module.exports = __webpack_public_path__ + "img/logo_en.c48d04c4.jpg";